import useFetchRefactored from 'civic-champs-shared/api/hooks/useFetchRefactored'
import { useCallback } from 'react'
import { OfferSignup } from './useOfferSignupsCollection'

export const useAddOfferSignups = (opportunityId: number) => {
  const [request] = useFetchRefactored<OfferSignup[]>()
  return useCallback(
    async userIds =>
      request({
        url: `/opportunities/${opportunityId}/signups`,
        method: 'post',
        config: { body: { userIds } },
      }),
    [request, opportunityId],
  )
}
